// Photo filenames for Holiday Party 2012
const HOLIDAY_PARTY_2012 = [
  'christmas-party-ad-2013_16527051661_m.jpg',
  'xmass-201201_15906163524_z.jpg',
  'xmass-201202_16342457249_z.jpg',
  'xmass-201203_16502724706_z.jpg',
  'xmass-201204_16527677552_z.jpg',
  'xmass-201205_15906143044_z.jpg',
  'xmass-201210_16341260250_z.jpg',
  'xmass-201211_15908544123_z.jpg',
  'xmass-201212_16341031568_z.jpg',
  'xmass-201213_16527008671_z.jpg',
  'xmass-201214_16341029918_z.jpg',
  'xmass-201215_16341033928_z.jpg',
  'xmass-201216_16528745565_z.jpg',
  'xmass-201220_15908548413_z.jpg',
  'xmass-201221_16528746945_z.jpg',
  'xmass-201222_16341268280_z.jpg',
  'xmass-201225_16342445879_z.jpg',
  'xmass-201226_16341273100_z.jpg',
  'xmass-201227_16341044498_z.jpg',
  'xmass-201228_16502721236_z.jpg',
  'xmass-201229_16341046228_z.jpg',
  'xmass-201230_16341278010_z.jpg',
  'xmass-201231_16502724056_l.jpg',
  'xmass-201232_16342814907_c.jpg',
];

export default HOLIDAY_PARTY_2012;
